import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './singleproject.css';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet';

const SingleProject = ({
  totalRequired = 0,
  fundedAmount = 0,
  developmentProgress = 0,
}) => {

  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const script = document.createElement("script");
  script.src = "https://static.elfsight.com/platform/platform.js";
  script.async = true;
  document.body.appendChild(script);

    axios
      .get(`https://cms.gammadda.lk/wp-json/wp/v2/posts?slug=${slug}&_embed`)
      .then(res => setPost(res.data[0]))
      .catch(err => console.error(err));
  }, [slug]);

  if (!post) return <p>Loading...</p>;
  const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null;

  const dynamicFundedAmount = post.acf?.funded || 0;
  const dynamicTotalRequired = post.acf?.totalrequiredfund || 0;

  fundedAmount = post.acf?.funded || 0;
  totalRequired = post.acf?.totalrequiredfund || 0;
  developmentProgress = post.acf?.development_progress || 0;

const extractMainCategory = (classList) => {
  return classList
    .filter(cls => cls.startsWith("category-") && cls !== "category-projects")
    .map(cls => cls.replace("category-", ""))[0] || null;
};

  
  const categorySlug = (extractMainCategory(post.class_list));  
  //post.class_list.find(c => c.startsWith("category-"));
 // ?.replace("category-", ""); // "water-sanitation-hygiene-2"

  console.log(fundedAmount);
  console.log(totalRequired);

  const fundingPercentage = Math.min((dynamicFundedAmount / dynamicTotalRequired) * 100, 100);
  const isFullyFunded = dynamicFundedAmount >= dynamicTotalRequired;

  {post && (
  <Helmet>
    <title>{post.title?.rendered}</title>
    <meta property="og:title" content={post.title?.rendered} />
    <meta property="og:description" content={post.acf?.short_description || 'Support this project'} />
    <meta property="og:image" content={featuredImage} />
    <meta property="og:url" content={`https://gammadda.lk/projects/${slug}`} />
    <meta property="og:type" content="article" />
  </Helmet>
)}

  return (
    <div className="w-container" style={{marginTop: "65px"}}>
      <div className=" section small">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-4">{post?.title?.rendered.replace(/&#038;/g, '&')}</h1>
          <p className="category-title"> {categorySlug}</p>

          {/* ====progress bar ==== */}
          <div className="container p-4 rounded">
            {/* Top Labels */}
            <div className="d-flex justify-content-between mb-2">
              <h5 className="text-danger fw-bold text-uppercase progresstitle">
                Total of Rs.{totalRequired.toLocaleString()} Required
              </h5>
              <h5 className="text-danger fw-bold text-uppercase progresstitle">
                Development Progress
              </h5>
            </div>

            <div class="container">
              <div class="row">
                  <div class="col" style={{paddingInlineEnd:0}}>
                    {/* Combined Progress Bar Container */}
                    <div className="position-relative border border-dark " style={{ height: '40px' }}>
                      {/* Funded Bar */}
                      <div
                        className="progress-bar bg-success position-absolute"
                        role="progressbar"
                        style={{
                          width: `${fundingPercentage}%`,
                          height: '100%',
                        }}
                        aria-valuenow={fundingPercentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>

                      {/* Development  Bar */}
                      {/* <div
                        className="progress-bar bg-success position-absolute"
                        role="developmentbar"
                        style={{
                          width: '50%',
                          height: '100%',
                        }}
                        aria-valuenow={developmentProgress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div> */}


                      {/* Vertical line to indicate development progress */}
                      <div
                        className="position-absolute border-start border-dark"
                        style={{
                          height: '100%',
                          // left: `50%`,
                        }}
                      ></div>
                    </div>
                  </div>

                 <div class="col" style={{paddingInlineStart:0}}>
                  {/* Combined Progress Bar Container */}
                  <div className="position-relative border border-dark " style={{ height: '40px' }}>             

                    {/* Development  Bar */}
                    <div
                      className="progress-bar bg-success position-absolute"
                      role="developmentbar"
                      style={{
                        width: `${developmentProgress}%`,
                        height: '100%',
                      }}
                      aria-valuenow={developmentProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>


                    {/* Vertical line to indicate development progress */}
                    <div
                      className="position-absolute border-start border-dark"
                      style={{
                        height: '100%',
                        // left: `50%`,
                      }}
                    ></div>
                  </div>
                  </div>
            </div>      
          </div>

            {/* Bottom Labels */}
            <div className="d-flex justify-content-between mt-2">
              <p className="mb-0">{fundingPercentage.toFixed(0)}% funded</p>
              <p className="mb-0">Rs.{fundedAmount.toLocaleString()} funded</p>
              <p className="mb-0">{developmentProgress}% completed</p>
            </div>
          </div>

          {/* ====END===== */}

        </div>
      </div>
      <div className="section small custom-section">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-12">
          {featuredImage && (
          <img
            src={featuredImage}
            alt={post?.title?.rendered || 'Post image'}
            className="w-full h-auto object-cover rounded-lg mb-6 wp-image-67 "          />
        )}
          </div>
          <div className="col-md-5 col-12 mt-3">  
          {isFullyFunded ? (
            <h2>Project fully funded. Thank you for your co-operation!</h2> ):( 
              <> 
              <h3 className="h3 project">Make a donation</h3>
            <p className='p-left'> {post.acf?.make_a_donation}
            </p>
            <h6 className="heading-6">Available methods</h6>
                <div className="methods-grid-wrapper" style={{ display: 'flex', gap: '40px' , alignItems: 'center', justifyContent: 'center'}}>
                  <div className="methods-small-wrap">
                  <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ac6_dialog_logo.png" loading="lazy" width="41" alt=""/>
                    <p className="methods-title">Via Dialog</p>
                  </div>
                  <div className="methods-small-wrap">
                  <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ac5_image%2030.png" loading="lazy" width="41" alt=""/>
                    <p className="methods-title">Bank transfer</p></div>
                </div>

                  <a href="/make-a-donation" className="button project-page">Donate now</a>
                  <div className="trusted-safe-wrap" style={{ display: 'flex', gap: '14px' }}>
                    <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57be1_lock.png" loading="lazy" height="40" width="auto" alt="" />
                    <p className="trusted-text">Donating through Gammada is safe, secure and easy with many payment options to choose</p>
                  </div> </>)}

              <h5 className="heading-11">Raise awareness</h5>
{/* 
              <div className="social-share-buttons" style={{ display: 'flex', gap: '10px', marginTop: '20px', alignItems: 'center', justifyContent: 'space-around' }}>

                <div className="social-card facebook" style={{ backgroundColor: 'blue' }}   >
                  <div className="icon-section">
                    <FontAwesomeIcon icon={faFacebook} style={{ backgroundColor: 'blue' }} size="1x" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank')} />
                  </div>
                  <div className="text-section">
                    <span>Facebook</span>
                  </div>
                </div>

                <div className="social-card">
                  <div className="icon-section">
                    <FontAwesomeIcon icon={faXTwitter} style={{ color: 'white' }} size="1x" onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`, '_blank')} />
                  </div>
                  <div className="text-section">
                    <span>Twitter</span>
                  </div>
                </div>

              </div> */}
              {/* <!-- Elfsight Social Share Buttons | Gammadda - Project page --> */}

                <div className="elfsight-app-0bf46313-3460-489b-8ae7-a16bf0e5ab20" data-elfsight-app-lazy></div>


            </div>
          </div>
        </div>

        <div
          className="content-section-project"
          dangerouslySetInnerHTML={{ __html: post?.content?.rendered || '' }}
        />
      </div>
    </div>
  )
}

export default SingleProject